import { eventChannel } from 'redux-saga'
import { put, take } from 'redux-saga/effects'
import socketIOClient from 'socket.io-client'
import { addNotification, socketEvent } from '../actions'
import { uiConstants } from '../../constants'

let socket //= socketIOClient(uris.socket)

export function* socketInitSaga() {
  try {
    const listener = eventChannel((emit) => {
      try {
        socket = socketIOClient(window.runConfig.socketUrl)
          .on('disconnect', () => {
            emit({ type: 'disconnected' })
          })
          .on('error', () => {
            emit({ type: 'error' })
          })
          .on('reconnect_error', () => {
            emit({ type: 'error' })
          })
          .on('reconnect_failed', () => {
            emit({ type: 'error' })
          })
          .on('connect_timeout', () => {
            emit({ type: 'error' })
          })
          .on('connect_error', () => {
            emit({ type: 'error' })
          })
          .on('connect_failed', () => {
            emit({ type: 'error' })
          })
          .on('reconnect_error', () => {
            emit({ type: 'error' })
          })
          .on('reconnect_failed', () => {
            emit({ type: 'error' })
          })
      } catch {
        console.log('socket error')
      }
      return () => socket.close()
    })
    while (true) {
      yield take(listener)
      // const event =
      // console.log(event)
      // if (event.type === 'error' || event.type === 'disconnected') {
      //   socket.disconnect()
      //   yield put(socketInitError())
      // }
    }
  } catch (error) {
    // console.log(error)
    yield put(
      addNotification(JSON.stringify(error), uiConstants.notification.error)
    )
  }
}

export function* socketSubscribeSaga(action) {
  try {
    const listener = eventChannel((emit) => {
      socket.emit('join_room', { room: action.payload })
      socket.on(action.payload, (data) => {
        emit(data)
      })
      return () => socket.close()
    })

    while (true) {
      const event = yield take(listener)
      yield put(socketEvent(event))
    }
  } catch (error) {
    yield put(
      addNotification(JSON.stringify(error), uiConstants.notification.error)
    )
  }
}

export function* socketUnsubscribeSaga(action) {
  try {
    socket.off(action.payload)
  } catch (error) {
    yield put(
      addNotification(JSON.stringify(error), uiConstants.notification.error)
    )
  }
}

export function* socketEmitSaga(action) {
  try {
    socket.emit(action.payload.event, action.payload.data)
  } catch (error) {
    yield put(
      addNotification(JSON.stringify(error), uiConstants.notification.error)
    )
  }
}
